<div class="sport-up-menu-container">
  <div class="sport-up-menu-box">
    <div class="sport-up-menu-item" (click)="navigateTo('/live')">
      <div class="menu-icon">
        <image-loader-utils url="live_bottom" extraClasses="up-mobil-menu"></image-loader-utils>
      </div>
      <div class="menu-name">
        {{ 'live' | translate }}
      </div>
    </div>
    <div class="sport-up-menu-item" (click)="selectedTimeStory(24)">
      <div class="menu-icon">
        <image-loader-utils url="date" extraClasses="up-mobil-menu"></image-loader-utils>
      </div>
      <div class="menu-name">
        {{ 'Today' | translate }}
      </div>
    </div>
    <div class="sport-up-menu-item" (click)="selectedTimeStory(3)">
      <div class="menu-icon">
        <image-loader-utils url="3hrs" extraClasses="up-mobil-menu" imageFormat="png"></image-loader-utils>
      </div>
      <div class="menu-name">
        {{ 'FilterDay3Hour' | translate }}
      </div>
    </div>
    <div class="sport-up-menu-item" (click)="selectedTimeStory(24)">
      <div class="menu-icon">
        <image-loader-utils url="24hours" extraClasses="up-mobil-menu" imageFormat="png"></image-loader-utils>
      </div>
      <div class="menu-name">
        <!-- {{ 'Favorites' | translate }} -->
        24 Saat
      </div>
    </div>
    <ng-container *ngIf="('isActiveBRSwipeWidget' | getEnv) === true; else noSwipe">
      <div class="sport-up-menu-item" (click)="this._UiHelper.openBrSwipeWidget(this._LocalizationService?.LANGCODE)">
        <div class="menu-icon">
          <image-loader-utils [url]="'swipe-icon1'" extraClasses="slidermenusvg swipeIcon"></image-loader-utils>
        </div>
        <div class="menu-name">
          <!-- {{ 'Results' | translate }} -->
          Swipe
        </div>
      </div>
    </ng-container>
    <ng-template #noSwipe>
      <div class="sport-up-menu-item" (click)="selectedTimeStory(48)">
        <div class="menu-icon">
          <image-loader-utils url="48hours" extraClasses="up-mobil-menu"></image-loader-utils>
        </div>
        <div class="menu-name">
          <!-- {{ 'Results' | translate }} -->
          48 Saat
        </div>
      </div>
    </ng-template>
  </div>
</div>

<div class="container spor-hightlight-menu">
  <div class="content" *ngIf="isOpenLeagueMenu">
    <top-leagues></top-leagues>
  </div>
</div>
<div class="container">
  <div class="content" *ngIf="isOpenSportsMenu">
    <ng-container *ngIf="mainData == undefined || mainData?.length < 1">
      <ngx-skeleton-loader [theme]="{ height: '19px', width: '220px', background: 'var(--white-color-300)' }" count="10"></ngx-skeleton-loader>
    </ng-container>

    <ng-container *ngFor="let item of mainData; let i = index">
      <div class="sports-menu-item sport-active">
        <div class="item-row" (click)="getCountriesBySportsID(item.SportId, i)">
          <div class="left">
            <image-loader-utils [url]="this.sportsSvgList[item.SportId]?.svgKey" extraClasses="sportmenusvg" [imageFormat]="'png'"></image-loader-utils>
          </div>
          <div class="mid">{{ item.SportName }}</div>
          <div class="right">
            {{ item.SportEventCount }}
            <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon right'"> </image-loader-utils>
          </div>
        </div>
        <div class="item-box" *ngIf="item.state">
          <ng-container *ngFor="let item2 of mainData[i].level; let k = index">
            <div class="sports-menu-dropdown">
              <div class="sports-menu-item row country" (click)="openAll(mainData[i].level[k], item2, item, i, k)">
                <div class="left">
                  <image-loader-flag-utils [url]="item2.IsoName" [isFlags]="true" extraClasses="flag-rounded" imageFormat="png"></image-loader-flag-utils>
                </div>
                <div class="mid">{{ item2.CategoryName }}</div>
              </div>
            </div>
            <div class="item-box2" *ngIf="item2.state">
              <ng-container *ngFor="let item3 of mainData[i].level[k].level; let l = index">
                <div class="menu-content-item">
                  <div class="left">
                    <league-utils [extraClass]="'left-menu-desktop'" [leagueId]="item3.BetradarId"></league-utils>
                  </div>

                  <div class="mid" (click)="openLeague(item, item3, item2)">{{ item3.TournamentName }}</div>
                  <div class="right">
                    <div class="event-count">
                      {{ item3.TournamentSportEventCount }}
                    </div>
                    <!-- <div (click)="add2TournamentFavs(item3, item2)">
                      <image-loader-utils url="star" [extraClasses]="'star-icon ' + (item3.checked ? 'star-icon-active' : 'star-icon-disabled')"></image-loader-utils>
                    </div> -->
                  </div>
                </div>
              </ng-container>
              <ng-container *ngFor="let item3 of mainData[i].level[k].outrights; let l = index">
                <div class="menu-content-item">
                  <div class="mid" [routerLink]="['/outright/' + item3.TournamentId]">{{ item3.TournamentName }} {{ 'SeasonBets' | translate }}</div>
                  <div class="right">
                    <div class="event-count">
                      {{ item3.TournamentSportEventCount }}
                    </div>
                    <!-- <div (click)="add2TournamentFavs(item3, item2)">
                      <image-loader-utils url="star" [extraClasses]="'star-icon ' + (item3.checked ? 'star-icon-active' : 'star-icon-disabled')"></image-loader-utils>
                    </div> -->
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<!-- <div class="desktop-left-menu-button-color btn white btn-h-30" (click)="openStats('statistics')">
  <div class="btn-text">
    {{ 'Results' | translate }}
  </div>
</div>
<div class="desktop-left-menu-button-color btn white mt-8 btn-h-30" (click)="openStats('livescore')">
  <div class="btn-text">
    {{ 'statistics' | translate }}
  </div>
</div> -->
